import React from 'react';
import { cn } from '@/lib/utils';
import { Skeleton } from './skeleton';

interface TableSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
}

export function TableSkeleton({
  rows = 8,
  columns = 5,
  showHeader = true,
  className,
  ...props
}: TableSkeletonProps) {
  return (
    <div className={cn('rounded-lg border border-border overflow-hidden', className)} {...props}>
      {/* Header skeleton */}
      {showHeader && (
        <div className="bg-background-subtle border-b border-border">
          <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
            {Array.from({ length: columns }).map((_, i) => (
              <div key={i} className="px-4 py-3">
                <Skeleton className="h-4 w-20" />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Body skeleton with shimmering rows */}
      <div className="bg-white divide-y divide-border">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="grid gap-4 px-4 py-3 hover:bg-background-subtle transition-colors" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Skeleton key={colIndex} className="h-4" style={{ width: `${Math.random() * 40 + 60}%` }} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
